/**
 * Anonymous EVII session id. Client-minted, held in localStorage so a visitor's
 * chat survives a reload within its server-side TTL. There is NO account: the id
 * is opaque and carries no PII — it only lets the server keep the short
 * conversation memory and enforce the per-session message cap. A Turnstile check
 * opens the session server-side once (fail-closed); the id alone never
 * authenticates anything.
 */
const STORAGE_KEY = 'evi-shop-evie-session';

function mint(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `evie-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/** The stable session id, minting + persisting one on first use. Falls back to
 *  a per-call ephemeral id if localStorage is unavailable (private mode). */
export function getEvieSessionId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length >= 8) return existing;
    const fresh = mint();
    localStorage.setItem(STORAGE_KEY, fresh);
    return fresh;
  } catch {
    return mint();
  }
}
